import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import { AttachmentComponent } from "@/components/pieces/editor/tiptap/AttachmentNode";

interface RichContentRendererProps {
  content?: string | null;
  className?: string;
}

export function RichContentRenderer({
  content,
  className,
}: RichContentRendererProps) {
  if (!content) return null;

  return (
    <ReactMarkdown
      className={className}
      rehypePlugins={[rehypeRaw]}
      components={{
        div: ({ node, ...props }) => {
          if ("data-exec-id" in props) {
            return (
              <AttachmentComponent
                urlOrError={String(node?.properties?.dataUrlOrError)}
                fileType={String(node?.properties?.dataFileType)}
                fileSize={Number(node?.properties?.dataFileSize)}
                error={String(node?.properties?.dataExecId).startsWith("error")}
              >
                {props.children}
              </AttachmentComponent>
            );
          }
          return <div {...props} />;
        },
        p: ({ ...props }) => (
          <p className="mb-2 whitespace-pre-wrap break-words" {...props} />
        ),
        ul: ({ ...props }) => {
          return (
            <ul
              {...props}
              className="mb-2 list-disc pl-5 [&_ul]:list-[revert]"
            />
          );
        },
        ol: ({ ...props }) => {
          return <ol {...props} className="mb-2 list-decimal pl-5" />;
        },
        li: ({ ...props }) => <li className="mb-2" {...props} />,
        code: ({ node, children, ...props }) => {
          return <code {...props}>{children}</code>;
        },
        pre: ({ children, ...props }) => {
          if (typeof children === "object" && children && "props" in children) {
            return <>{children}</>;
          }

          return (
            <div className="code-block bg-gray-900">
              <pre className="code-content text-gray-200" {...props}>
                {children}
              </pre>
            </div>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
